export class PagetransitionConstant {
  static readonly FORWARD: string = "slide-left";
  static readonly BACKWARD: string = "slide-right";
}
